export default class Item {

  constructor(
    IdCliente = null,
    IdItem = null,
    Tipo = 'GERAL',
    Descricao = '',
  ) {
    this.IdCliente = IdCliente;
    this.IdItem = IdItem;
    this.Tipo = Tipo;
    this.Descricao = Descricao;
  }
  
}